exports.components = {
  "component---src-pages-havarie-js": () => import("./../../../src/pages/havarie.js" /* webpackChunkName: "component---src-pages-havarie-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

